import React, { useState, useEffect } from "react";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { Container, Input, Label } from "./styles";
import { ModalDivX } from "../../../ModalDivX";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../ModalLoader";
import { Alert } from "../../../Error/Alert";
import { Paperclip, Plus } from "react-feather";
import { IAnexos } from "..";
import { Button } from "./styles";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { isRural } from "../../../../Utils/isRural";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel_id: number;
  handleAddAnexo(a: IAnexos): void;
}

export function AddAnexo({ open, onClose, imovel_id, handleAddAnexo }: Props) {
  const [anexo, setAnexo] = useState({} as IAnexos[]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const [file, setFile] = useState({} as any);
  const [fileSize, setFileSize] = useState(0);
  const [fileTeste, setFileTeste] = useState("");
  const [titulo, setTitulo] = useState("");

  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();

  function validaForm() {
    if (titulo.trim().length == 0) {
      setError({
        message: "O título não pode ser vázio.",
        title: "Título inválido!",
      });
      return false;
    }
    if (fileSize > 10485760) {
      setError({
        message: "O anexo não deve possuir mais que 10MB.",
        title: "Anexo muito grande!",
      });
      return false;
    }

    if (fileSize == 0) {
      setError({
        message: "Selecione um anexo para confirmar a alteração!",
        title: "Nenhum anexo selecionado!",
      });
      return false;
    }

    return true;
  }

  async function post() {
    if (validaForm())
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("TITULO", titulo);
        isRural()
          ? formData.append("IMOVEL_RURAL_ID", `${imovel_id}`)
          : formData.append("IMOVEL_ID", `${imovel_id}`);

        if (funcionarioCartorioIsLogged) {
          await checarTokenFuncionario();
        }

        if (cartorioIsLogged) {
          await checarToken();
        }
        const { data } = await api.post(`/imovel-anexos`, formData);
        handleAddAnexo(data);
        setTitulo("");
        setAnexo({} as any);
        setFileSize(0);
        setFileTeste("");
        onClose();
      } catch (error) {
        setError({
          title: "Não foi possível salvar a alteração!",
          message:
            "Ocorreu um erro durante a criação do anexo, tente novamente!",
        });
      } finally {
        setLoading(false);
      }
  }

  return (
    <>
      <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
        <ModalDivX execute={onClose} />

        <Container>
          <Input
            placeholder="TÍTULO"
            value={titulo}
            onChange={(ev) => setTitulo(ev.target.value)}
            maxLength={50}
          />
          <Label>
            <Paperclip />
            {fileTeste}

            <Input
              id="#fileInput"
              placeholder=""
              type="file"
              accept="image/*, application/pdf"
              hidden={true}
              onChange={(ev) => {
                if (ev.target.files) {
                  if (ev.target.files[0].size) {
                    setFile(ev.target.files[0]);
                    setFileSize(ev.target.files[0].size);
                  } else {
                    setFileSize(0);
                  }
                }

                setFileTeste(ev.target.value);
              }}
            />
          </Label>
          <Button onClick={post}>CONFIRMAR</Button>
        </Container>
      </Modal>
      <ModalLoader loading={loading} />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </>
  );
}
